module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "AN"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#int"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONATHAN")]), _vm._v(" A. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INEBAUGH")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("On October 4, 1529, Martin Luther wrote a letter to his wife. He was in Marburg at the urging of Landgrave Philip of Hesse, who had brought together several leading Lutheran and Reformed theologians in an attempt to secure the theological agreement necessary to establish a united evangelical front against the Hapsburgs. The participants in this Marburg Colloquy were able to produce a joint doctrinal statement, the “Marburg Articles,” and the list of signatories reads like a who’s who of the early Reformation: Martin Luther, Philip Melanchthon, Justus Jonas, Andreas Osiander, Johannes Brenz, Johannes Oecolampadius, Huldrych Zwingli, Martin Bucer, and Caspar Hedio.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Despite far-reaching agreement on such essentials of the evangelical faith as the doctrine of the Trinity, Christology, original sin, and justification "), _c('i', [_vm._v("sola fide")]), _vm._v(", the Marburg Colloquy is mainly remembered for what it did not accomplish: full theological concord between the Lutheran and Reformed traditions. According to the final article, “we have not been able to agree at this time whether the true body and blood of Christ are corporeally present in the bread and wine.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" This admission reflects the record of the exchange between the loudest Lutheran and Reformed theologians at Marburg—Luther and Zwingli. Luther continually cited the “clear words” of Scripture—“This is my body”—and invited Zwingli to “submit.” Zwingli marshaled texts like John 6:63, “the flesh profits nothing,” insisting “this passage breaks your neck.” “Don’t be too proud,” Luther replied. “German necks don’t break so easily.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Luther’s letter to his wife, Katharina, captures this dynamic of broad and basic agreement together with particular but pointed disagreement: “[We are] of one opinion in almost everything,” but “at the Lord’s Supper they will allow bread to be only physically present and Christ to be only spiritually present.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3",
      "id": "fn3"
    }
  }, [_vm._v("3")]), _vm._v(" This “but” proved to be a line in the sand. As Heiko Oberman points out, the following year, at the Diet of Augsburg, the evangelicals were unable to offer a unified confessional document, submitting instead the Augsburg Confession, a statement from Zwingli, and the Tetrapolitian Confession."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4",
      "id": "fn4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This event is more than an episode on the way to distinct Lutheran and Reformed identities, however. It is an instance of concrete conversation between Lutheran and Reformed theologians. Considered in these terms, Luther’s characterization of the discussion and debate in his letter to Katharina reads, with five centuries of retrospect, like a prophecy: when Lutherans and the Reformed talk, “we are of one opinion in almost everything, but . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 1529 at Marburg, the definitions of and distinction between law and gospel seem to fall under the “almost everything” of which the Lutherans and Reformed were of “one opinion.” Article 7 explicitly affirms “justification before God . . . for the sake of his Son, in whom we believe” apart from the law, and articles 4 through 7 all implicitly employ the distinction between law and gospel as a criterion by which Christ "), _c('i', [_vm._v("alone")]), _vm._v(" is identified as the subject of God’s saving grace: “no deed, social status, or religious order can free us” (article 5); “all of humanity would be damned had not Jesus Christ come to help with his life and death” (article 4)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5",
      "id": "fn5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The distinction between law and gospel began germinating in Luther’s theology at least as early as his 1513–1515 lectures on the Psalms, as he modulated the traditional distinction between the letter and the spirit from the fourfold method of interpretation into the key of God’s killing and resurrecting words."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6",
      "id": "fn6"
    }
  }, [_vm._v("6")])]), _vm._v(" By 1518 and 1520, however, this distinction had fully broken the surface, first as a soteriological and epistemological criterion in the Heidelberg Disputation—“the law says ‘do this,’ and it is never done. Grace says, ‘believe in this,’ and everything is already done”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7",
      "id": "fn7"
    }
  }, [_vm._v("7")])]), _vm._v("—and then as a hermeneutic in "), _c('i', [_vm._v("The Freedom of the Christian")]), _vm._v("—“the entire scripture of God is divided into two parts: commandments and promises.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn8",
      "id": "fn8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("For Luther, this was the theological crux: “Anyone who can properly distinguish the gospel from the law may thank God and know that he is a theologian.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn9",
      "id": "fn9"
    }
  }, [_vm._v("9")]), _vm._v(" Translating this distinction from hermeneutics to homiletics, Luther writes: “This is the sermon which we should daily study. . . . In it both imprisonment and redemption, sin and forgiveness, wrath and grace, death and life are shown to us. . . . The first thing about sin and death is taught us by the law, the second about redemption, righteousness and life by the gospel of Christ. One must preach both. One must preach the law so that people come to a knowledge of their sins. . . . One should preach the gospel so that one comes to know Christ and his benefits.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn10",
      "id": "fn10"
    }
  }, [_vm._v("10")])]), _vm._v(" This begins to express the meaning of and difference between law and gospel as Luther understood them. The law is God’s word by which he diagnoses sinners: condemned and dead. The gospel is God’s word by which he delivers sinners: forgiven and made alive. God’s law reveals sin and seals the coffin of the old Adam. God’s gospel is preached at the graveside of the old, and it is a word that redeems and resurrects. The law sounds like Nathan’s words to David: “You are the man” (2 Sam. 12:7). The gospel sounds like Jesus’s words to the dead: “Lazarus, come out” (John 11:43). The distinction between law and gospel is not first a hermeneutical and homiletical strategy that provides categories by which to index, interpret, and announce God’s word. Law and gospel name the actions of the “living and active” word (Heb. 4:12) by which God interprets hearers, imprisoning in disobedience in order to have mercy (Rom. 11:32), killing and making alive (1 Sam. 2:6). For Luther, therefore, this was never just theological or pastoral theory; it was personal experience. In one of his reminiscences about the “Reformation breakthrough,” he recalls, “I regarded both [God’s law and his gospel] as the same thing. . . . When I realized the law was one thing, and the gospel another, I broke through and was free.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn11",
      "id": "fn11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As Luther’s letter indicates, this is not just his own unique theology or experience. The distinction between law and gospel is shared by Lutheran and Reformed theology; it is part of the “almost everything” on which the traditions are of “one opinion.” Zacharias Ursinus, commenting on the structure of the Heidelberg Catechism, says, “the catechism in its primary and most general sense, may be divided as the doctrine of the church, into the law and gospel. . . . The first treats of the misery of man, the second of his deliverance "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("from this misery.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn12",
      "id": "fn12"
    }
  }, [_vm._v("12")]), _vm._v(" John Calvin spoke repeatedly of “the antithesis between legal and gospel righteousness”—the way “the gospel differs from the law”—and insisted that an awareness of this distinction “can extricate us from many difficulties,” as it reveals “that the righteousness which is given us through the gospel has been freed of all conditions of the law.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn13",
      "id": "fn13"
    }
  }, [_vm._v("13")])]), _vm._v(" Theodore Beza, in his "), _c('i', [_vm._v("Confessio")]), _vm._v(", both distinguished law and gospel—“We divide this word into two principal parts or kinds: the one is called ‘law,’ the other the ‘gospel’”—and echoed Luther’s sense of the significance of this distinction: “Ignorance of this distinction between law and gospel is one of the principal sources of the abuse which corrupted and still corrupt Christianity.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn14",
      "id": "fn14"
    }
  }, [_vm._v("14")])]), _vm._v(" William Perkins, again like Luther, made the move from hermeneutics to homiletics: “The basic principle in application is to know whether the passage is a statement of law or of gospel.” This is crucial because, “when the word is preached, the law and the gospel operate differently. . . . The law exposes the disease of sin . . . but provides no remedy for it. . . . By contrast, a statement of the gospel,” which differs from the law in that “it has the power of the Holy Spirit joined to it,” does not call for “works” and pronounce a “curse” but “speaks of Christ and his benefits.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn15",
      "id": "fn15"
    }
  }, [_vm._v("15")])]), _vm._v(" Quotations like these, which could be multiplied many times over, confirm Louis Berkhof’s assertion that “The churches of the Reformation”—not the Lutheran or Reformed tradition but “churches of the Reformation”—“from the very beginning distinguished between the law and the gospel as the two parts of the word of God. . . . The law comprises everything in scripture which is a revelation of God’s will in the form of a command or prohibition, while the gospel embraces everything, whether it be in the Old Testament or the New, that pertains to the work of reconciliation and that proclaims the seeking and redeeming love of God in Christ Jesus.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn16",
      "id": "fn16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This kind of basic agreement on the distinction between law and gospel is significant. For the reformers, this was something they shared, something that "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("picked them out as evangelicals and differentiated them from their theological opponents. In Luther’s words, “You will find nothing about this distinction between law and gospel in the books of the monks, the canonists, and the recent and ancient theologians.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn17",
      "id": "fn17"
    }
  }, [_vm._v("17")]), _vm._v(" But you do find it in the books of both Lutheran and Reformed theologians. While “for centuries there has been a remarkable silence about [the distinction between law and gospel] in all the schools and churches,” the Reformation schools—Lutheran and Reformed alike—speak: “The word of God is both law and gospel.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn18",
      "id": "fn18"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Agreement, however, is only half the story. As Luther discovered through long experience with the distinction between law and gospel, it is a difficult art. At “the level of words,” the difference between law and gospel is obvious: “There is no one so stupid that he does not recognize how definite this distinction between law and grace is.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn19",
      "id": "fn19"
    }
  }, [_vm._v("19")])]), _vm._v(" One particularly memorable rendition of this “definite distinction” comes from a preface to a piece of Elizabethan Protestant propaganda, John Foxe’s "), _c('i', [_vm._v("Acts and Monuments of the English Martyrs")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("There is nothing more comfortable for troubled consciences than to be instructed in the difference between the law and the gospel. The law shows us our sin; the gospel shows us the remedy for it. The law shows our condemnation; the gospel shows our redemption. The law is a word of ire; the gospel is a word of grace. The law is a word of despair; the gospel is a word of comfort. The law is a word of unrest; the gospel is a word of peace. The law says pay your debt; the gospel says Christ has paid it. The law says you are a sinner, despair you shall be damned. The gospel says your sins are forgiven, be comforted you shall be saved. The law says where is your righteousness? The gospel says Christ is your righteousness."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn20",
      "id": "fn20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Here, as Luther suggests, the distinction is concrete and clear. But it is also said to be “comfortable.” This gestures toward a more fundamental level at which the distinction between law and gospel operates, what Luther termed “the level of reality and experience.” If at the “level of words” the distinction is so obvious that “no one is so stupid that he does not recognize” it, at this "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("lived level—“the level of reality and experience”—the distinction between law and gospel “is the most difficult thing there is.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn21",
      "id": "fn21"
    }
  }, [_vm._v("21")]), _vm._v(" For Luther, the reason this simple linguistic distinction is a near existential impossibility is that when a person is suffering and aware of his or her sin, it “is the most difficult thing” to ignore the condemning voice of the law that speaks against the person and listen instead to the forgiving voice of the gospel that speaks for the person. What this means—theologically, pastorally, and personally—is that “There is no one living on earth who knows how to distinguish rightly between the law and the gospel. . . . Only the Holy Spirit knows this art.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn22",
      "id": "fn22"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If “no one living on earth . . . knows how to distinguish rightly between the law and the gospel,” then perhaps it is unsurprising that this is not simply a theme on which Lutheran and Reformed theologians have agreed but has also been a source of debate and self-differentiation. It does not, in other words, only live under Luther’s “almost everything” on which the traditions are of “one opinion.” Rather, when Lutheran and Reformed theologians talk about the distinction between law and gospel, the conversation on this shared theme tends to run along the lines of Luther’s letter to Katharina: “we are of one opinion in almost everything, but . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Herman Bavinck articulates this dynamic of agreement-and-disagreement in his "), _c('i', [_vm._v("Reformed Dogmatics")]), _vm._v(". Both the Lutheran and Reformed traditions agree, “the word of God, both as law and gospel, is the revelation of God’s will.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn23",
      "id": "fn23"
    }
  }, [_vm._v("23")])]), _vm._v(" Despite this shared affirmation, Bavinck argues that Reformed theology and Lutheran theology have “a very different view.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn24",
      "id": "fn24"
    }
  }, [_vm._v("24")])]), _vm._v(" One symptom of this difference, as Bavinck diagnoses it, is that while “Lutherans almost exclusively have an eye for the accusing and condemning function of the law,” for the Reformed this “pedagogical use of the law” is only “accidentally necessary because of sin,” and as such, “among the Reformed the law occupies a much larger place in the doctrine of gratitude than in that of misery.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn25",
      "id": "fn25"
    }
  }, [_vm._v("25")])]), _vm._v(" This exposes a potential fault line: Is the law fundamentally or even exclusively for the world as fallen and "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("thus the person as sinner, or is the law originally and principally for the world as created and thus the person as redeemed?")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("One way to approach this question is via the threefold use of the law. The Lutheran and Reformed confessions both affirm a political use of the law (i.e., restraining sin), a theological use of the law (i.e., revealing sin), and a third use (i.e., a use of the law for Christians). This formal agreement, however, can mask deep discontinuity. As Bavinck notes, for Lutherans, the third use of the law “is solely necessary since and insofar as believers continue to be sinners.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn26",
      "id": "fn26"
    }
  }, [_vm._v("26")]), _vm._v(" This captures a recurring theme in Luther’s "), _c('i', [_vm._v("Antinomian Disputations")]), _vm._v(": “the law needs to remain . . . insofar as we live and act here in the flesh”; “the law is still given to the holy and righteous . . . not insofar as he is righteous and holy, but insofar as he is flesh”; “because we are not perfect and sin in the present life, the law is to be taught.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn27",
      "id": "fn27"
    }
  }, [_vm._v("27")])]), _vm._v(" For Luther, texts like Galatians 3:19 and 1 Timothy 1:9 indicate that the law, while “holy, righteous, and good” (Rom. 7:12; cf. 1 Tim. 1:8), is given “because of transgressions” and is “not for the righteous but for . . . sinners.” "), _c('i', [_vm._v("The Book of Concord")]), _vm._v(", the collection of Lutheran confessional documents, takes the same line. The law, like the gospel, should be preached to Christians, not because they are righteous "), _c('i', [_vm._v("extra nos")]), _vm._v(", but because they are sinners "), _c('i', [_vm._v("in se")]), _vm._v("—because “the old Adam hangs on” like an “obstinate donkey.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn28",
      "id": "fn28"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is just here that Bavinck insists, “The Reformed held a very different view.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn29",
      "id": "fn29"
    }
  }, [_vm._v("29")])]), _vm._v(" Whereas Luther takes his bearings from the law given at Sinai in the context of sin, Bavinck starts in Eden, “before the fall.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn30",
      "id": "fn30"
    }
  }, [_vm._v("30")])]), _vm._v(" Because “the law” was given “before the fall,” its political and theological functions—that is, God’s uses of the law in relation to sin—can only be “accidentally necessary.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn31",
      "id": "fn31"
    }
  }, [_vm._v("31")])]), _vm._v(" This reflects Calvin’s view that while “the law, which among sinners can engender nothing but death, ought among the saints to have a better and more excellent "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("use.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn32",
      "id": "fn32"
    }
  }, [_vm._v("32")]), _vm._v(" This means that, in contrast to Luther, who called the theological use of the law the “primary purpose” and “chief and proper use,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn33",
      "id": "fn33"
    }
  }, [_vm._v("33")])]), _vm._v(" for Calvin the third use is the “principal use,” the use of the law that “pertains more closely to the proper purpose of the law.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn34",
      "id": "fn34"
    }
  }, [_vm._v("34")])]), _vm._v(" On Bavinck’s reading, “proper” and “principal” seem to mean something like “original” and “created.” His rendering of the distinction between law and gospel is thus oriented to creation “before the fall” and its restoration: “the gospel is temporary; the law is eternal and precisely that which is restored by the gospel.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn35",
      "id": "fn35"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is exactly this complex of themes that Werner Elert, a Lutheran theologian who taught at Erlangen, picks up in his short book "), _c('i', [_vm._v("Law and Gospel")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn36",
      "id": "fn36"
    }
  }, [_vm._v("36")])]), _vm._v(" Elert’s publication was provoked by Karl Barth’s 1935 reversal of the traditional order of law and gospel, “Gospel and Law.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn37",
      "id": "fn37"
    }
  }, [_vm._v("37")])]), _vm._v(" As the title of chapter 9 of Elert’s book suggests, however, his polemic is as much “a critique of Calvin” as it is a response to Barth. Taking up the question of the third use of the law, Elert agrees with Bavinck that for the Lutheran confession the Christian requires the sin-restraining and the sin-revealing law because the Christian is a “pardoned sinner,” because in his or her “earthly existence” the “old Adam still infects [the person’s] nature.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn38",
      "id": "fn38"
    }
  }, [_vm._v("38")])]), _vm._v(" Elert critiques Calvin for thinking that there is a “nomological existence in which the law does not turn against the man who lives with it” ("), _c('i', [_vm._v("lex semper accusat")]), _vm._v(") and thereby rejects Calvin’s notion of a “better and more excellent use” of the law among the saints."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn39",
      "id": "fn39"
    }
  }, [_vm._v("39")])]), _vm._v(" Following Luther, the theological use is not accidental for Elert; rather, “the proper and absolute use of the law is to terrify with lightning (as on Mt. Sinai) . . . with a thunderbolt to burn and crush that brute which is called the presumption of righteousness.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn40",
      "id": "fn40"
    }
  }, [_vm._v("40")])]), _vm._v(" This leads to Elert’s most basic critique. Where Bavinck declared “the gospel is temporary; the law is eternal and precisely that which is restored by the gospel,” Elert voices the apparently opposite pole: “[Calvin] sees in the law the ultimate criterion for measuring man’s relation to God. This means that the gospel did not provide a new way of salvation, but served only to clarify "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("the law. It stepped in as an auxiliary aid since the law alone did not achieve its goal. For Calvin, the gospel stands in service of the law. . . . [But] it is not the gospel that serves the law, but the law that serves the gospel. . . . Either the law or the gospel is the end of God’s ways with men, but not both.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn41",
      "id": "fn41"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Listening in on these moments of this centuries-old and ongoing conversation puts some of the recurring topics on the table. Does the law operate in Eden or only east of it? What is the “proper” function of the law, and is the third use for the Christian "), _c('i', [_vm._v("qua peccator")]), _vm._v(" or "), _c('i', [_vm._v("qua iustus")]), _vm._v("? Is the divine-human relation fundamentally legal or evangelical? Other voices in the conversation between the Lutheran and Reformed tradition would add other questions. For Hermann Sasse, the real “difference” is that “the Reformed believe that both law and gospel are parts of Christ’s real work” whereas “the Lutheran Church . . . teaches that the preaching of the law is the ‘strange,’ and the preaching of the gospel is the ‘real,’ work of Christ.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn42",
      "id": "fn42"
    }
  }, [_vm._v("42")])]), _vm._v(" Berkhof identifies a “difference between the Lutherans and the Reformed” in that the Lutheran emphasis on the theological use of the law considers the function of the law in justification while the Reformed stress on the third use pays “more attention to the law in connection with the doctrine of sanctification.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn43",
      "id": "fn43"
    }
  }, [_vm._v("43")])]), _vm._v(" The Reformed, at times, seem to define the law more in terms of its nature as a “revelation of the will of God” and “an expression of God’s being,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn44",
      "id": "fn44"
    }
  }, [_vm._v("44")])]), _vm._v(" whereas Lutherans regularly define the law by its function: “Whatever shows sin, wrath, and death exercises the office of the law”; “The law and the showing of sin, or the revelation of wrath are synonymous terms.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn45",
      "id": "fn45"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If these themes indicate some of the specific points of debate, there are also more fundamental ways of framing the conversation. In the wake of the Westminster Standards, Reformed theology has tended to understand law and gospel within the frame of covenant theology. On the one hand, this preserves a distinction, as the difference between the covenant of works and the covenant of grace names distinct modes of God’s relation to creatures. At the same time, covenant provides a category more basic than law and gospel, a theological space capacious enough to hold God’s two words "), _c('i', [_vm._v("together")]), _vm._v(", even if "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("they are only together in distinction."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn46",
      "id": "fn46"
    }
  }, [_vm._v("46")]), _vm._v(" For at least some Lutherans, any theology that holds law and gospel together within a more basic category (e.g., covenant, word of God, revelation) differs so fundamentally from the Lutheran conviction that such “unity can only be asserted in the face of agonizing spiritual struggle ("), _c('i', [_vm._v("Anfechtung")]), _vm._v(")” that the two approaches represent “fundamentally different ways of studying theology.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn47",
      "id": "fn47"
    }
  }, [_vm._v("47")])]), _vm._v(" Another root of these divergences may lie in differing understandings of the scope and subject matter of theology. For Calvin, theology is concerned, quite expansively and comprehensively, with “the knowledge of God and of ourselves.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn48",
      "id": "fn48"
    }
  }, [_vm._v("48")])]), _vm._v(" Within this frame questions about the prelapsarian law and its relation to and reflection of God’s eternal being are entirely apropos. For Luther, however, theology’s purview is narrower: “the real subject of theology is the human being, accused of sin and lost, and God, the one who justifies and rescues the sinful human being.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn49",
      "id": "fn49"
    }
  }, [_vm._v("49")])]), _vm._v(" Here, where the focus is not God and the human being in general but only the sinning human and the justifying God, theology’s task is not the consideration of all truth from before creation to the consummation; it is the distinction between and delivery of the word that kills (law) and the word that makes alive (gospel)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn50",
      "id": "fn50"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("And so the conversation goes. The Marburg Colloquy was one episode in this discussion, but Luther’s description of it in his letter to Katharina captures the long course of the conversation: “we are of one opinion in almost everything, but . . .” The extent of this “almost everything” encouraged other reformers that the “but” was temporary, that further dialogue could end in full confessional unity. On February 10, 1549, Thomas Cranmer wrote to Philip Melanchthon: “I am aware that you have often desired that wise and godly men should take counsel together, and, having compared their opinions, send "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("forth under the sanction of their authority some work, that should embrace the chief subjects of ecclesiastical doctrine. . . . This object we are anxiously endeavoring to accomplish with our utmost power. We therefore request you to communicate your counsels and opinions to us in person.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn51",
      "id": "fn51"
    }
  }, [_vm._v("51")]), _vm._v(" John Calvin received a similar letter, and as his reply from Geneva in April 1552 indicates, he supported such a gathering: “Most illustrious Lord, you truly and wisely judge that in the present disturbed state of the church no more suitable remedy can be adopted than the assembling together of godly and discreet men, well disciplined in the school of Christ, who shall openly profess their agreement in the doctrines of religion.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn52",
      "id": "fn52"
    }
  }, [_vm._v("52")])]), _vm._v(" Calvin, however, like Melanchthon, never sailed for England: “if I can be of any service, I shall not shrink from crossing ten seas,” he wrote. Nevertheless, he added, “I hope my want of ability will occasion me to be excused.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn53",
      "id": "fn53"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The meeting never happened. There never was “an agreement of learned men . . . well framed according to the standard of scripture” that would allow “the churches . . . far separated from each other . . . to unite.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn54",
      "id": "fn54"
    }
  }, [_vm._v("54")])]), _vm._v(" This book is far from the product Melanchthon, Cranmer, and Calvin dreamed of. It does not take up all the “chief subjects of ecclesiastical doctrine”; it carries no more authority than all honest and open conversation; and whether its contributors are “wise and godly” is for the one who said “judgment is mine” to decide. But this book does join in a conversation and invites its readers to listen in and keep it going.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")]), _vm._v(". WA 30:3.160–71.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "rfn2"
    }
  }, [_vm._v("2")]), _vm._v(". See C. Hedio’s report in "), _c('i', [_vm._v("Das Marburger Religionsgespräch")]), _vm._v(" (1529), ed. G. May (Gütersloh, 1970), 23, cited in H. A. Oberman, "), _c('i', [_vm._v("Luther: Man between God and the Devil")]), _vm._v(" (New Haven: Yale University Press, 1989), 237n22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3",
      "id": "rfn3"
    }
  }, [_vm._v("3")]), _vm._v(". WABr 5:154.16; October 4, 1529.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4",
      "id": "rfn4"
    }
  }, [_vm._v("4")]), _vm._v(". Oberman, "), _c('i', [_vm._v("Luther")]), _vm._v(", 237.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5",
      "id": "rfn5"
    }
  }, [_vm._v("5")]), _vm._v(". WA 30:3.160–71.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6",
      "id": "rfn6"
    }
  }, [_vm._v("6")]), _vm._v(". See G. Ebeling, “The New Hermeneutics and the Early Luther,” "), _c('i', [_vm._v("Theology Today")]), _vm._v(" 21 (1964): 34–46.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7",
      "id": "rfn7"
    }
  }, [_vm._v("7")]), _vm._v(". "), _c('i', [_vm._v("LW")]), _vm._v(" 31:56.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8",
      "id": "rfn8"
    }
  }, [_vm._v("8")]), _vm._v(". "), _c('i', [_vm._v("LW")]), _vm._v(" 31:348.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn9",
      "id": "rfn9"
    }
  }, [_vm._v("9")]), _vm._v(". "), _c('i', [_vm._v("LW")]), _vm._v(" 26:115.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10",
      "id": "rfn10"
    }
  }, [_vm._v("10")]), _vm._v(". WA 45:3.19, quoted in H. J. Iwand, "), _c('i', [_vm._v("The Righteousness of Faith according to Luther")]), _vm._v(", trans. R. H. Lundell (Eugene, OR: Wipf and Stock, 2008), 90n77.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn11",
      "id": "rfn11"
    }
  }, [_vm._v("11")]), _vm._v(". "), _c('i', [_vm._v("LW")]), _vm._v(" 54:442.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn12",
      "id": "rfn12"
    }
  }, [_vm._v("12")]), _vm._v(". Z. Ursinus, "), _c('i', [_vm._v("The Commentary on the Heidelberg Catechism")]), _vm._v(", trans. G. W. Williard (Phillipsburg, NJ: Presbyterian and Reformed, 1852), 13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn13",
      "id": "rfn13"
    }
  }, [_vm._v("13")]), _vm._v(". J. Calvin, "), _c('i', [_vm._v("Institutes of the Christian Religion")]), _vm._v(", ed. J. T. McNeill, trans. F. L. Battles (Philadelphia: Westminster, 1960), 3.11.14, 17, 18.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn14",
      "id": "rfn14"
    }
  }, [_vm._v("14")]), _vm._v(". "), _c('i', [_vm._v("The Christian Faith")]), _vm._v(", "), _c('i', [_vm._v("by Theodore Beza")]), _vm._v(", trans. J. Clark (Lewes, UK: Focus Christian Ministry Trust, 1992), 41.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn15",
      "id": "rfn15"
    }
  }, [_vm._v("15")]), _vm._v(". W. Perkins, "), _c('i', [_vm._v("The Art of Prophesying")]), _vm._v(" (Edinburgh: Banner of Truth, 1996), 54. For these and more references on the distinction between law and gospel in the Reformed tradition, see M. S. Horton, “Post-Reformation Reformed Anthropology,” in "), _c('i', [_vm._v("Personal Identity in Theological Perspective")]), _vm._v(", ed. R. Lints, M. S. Horton, and M. Talbot (Grand Rapids: Eerdmans, 2006), 45–69.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn16",
      "id": "rfn16"
    }
  }, [_vm._v("16")]), _vm._v(". L. Berkhof, "), _c('i', [_vm._v("Systematic Theology")]), _vm._v(" (Grand Rapids: Eerdmans, 1941), 612.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn17",
      "id": "rfn17"
    }
  }, [_vm._v("17")]), _vm._v(". "), _c('i', [_vm._v("LW")]), _vm._v(" 26:313.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn18",
      "id": "rfn18"
    }
  }, [_vm._v("18")]), _vm._v(". "), _c('i', [_vm._v("LW")]), _vm._v(" 26:313; 33:105. Cf. Herman Bavinck, "), _c('i', [_vm._v("Reformed Dogmatics")]), _vm._v(", vol. 4, "), _c('i', [_vm._v("Holy Spirit, Church, and New Creation")]), _vm._v(", ed. John Bolt, trans. John Vriend (Grand Rapids: Baker Academic, 2008), 448: “the word of God, both as law and gospel, is the revelation of the will of God.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn19",
      "id": "rfn19"
    }
  }, [_vm._v("19")]), _vm._v(". "), _c('i', [_vm._v("LW")]), _vm._v(" 26:143–44.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn20",
      "id": "rfn20"
    }
  }, [_vm._v("20")]), _vm._v(". Adapted from “Patrick’s Places,” trans. John Frith, in J. Foxe, "), _c('i', [_vm._v("Acts and Monuments of the English Martyrs")]), _vm._v(", vol. 4, ed. S. R. Cattley (London: Seely and Burnside, 1837), 566.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn21",
      "id": "rfn21"
    }
  }, [_vm._v("21")]), _vm._v(". "), _c('i', [_vm._v("LW")]), _vm._v(" 26:445.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn22",
      "id": "rfn22"
    }
  }, [_vm._v("22")]), _vm._v(". "), _c('i', [_vm._v("LW")]), _vm._v(" 54:127.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn23",
      "id": "rfn23"
    }
  }, [_vm._v("23")]), _vm._v(". Bavinck, "), _c('i', [_vm._v("Reformed Dogmatics")]), _vm._v(", 4:448. Note, however, that whereas Bavinck says that “law and gospel . . . differ especially in content” because the former demands “human works” and the latter invites the acceptance of “the righteousness of Christ” (4:454), Iwand insists, “both the law and the gospel have the same content,” quoting Luther, who writes, “The law requires that we must have love and have Jesus Christ, but the gospel offers both and brings both” ("), _c('i', [_vm._v("The Righteousness of Faith")]), _vm._v(", 42; cf. "), _c('i', [_vm._v("LW")]), _vm._v(" 25:326).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn24",
      "id": "rfn24"
    }
  }, [_vm._v("24")]), _vm._v(". Bavinck, "), _c('i', [_vm._v("Reformed Dogmatics")]), _vm._v(", 4:455.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn25",
      "id": "rfn25"
    }
  }, [_vm._v("25")]), _vm._v(". Bavinck, "), _c('i', [_vm._v("Reformed Dogmatics")]), _vm._v(", 4:454–55.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn26",
      "id": "rfn26"
    }
  }, [_vm._v("26")]), _vm._v(". Bavinck, "), _c('i', [_vm._v("Reformed Dogmatics")]), _vm._v(", 4:455.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn27",
      "id": "rfn27"
    }
  }, [_vm._v("27")]), _vm._v(". M. Luther, "), _c('i', [_vm._v("Solus Decalogus est Aeternus: Martin Luther’s Complete Antinomian Theses and Disputations")]), _vm._v(", ed. and trans. H. Sonntag (Minneapolis: Lutheran Press, 2008), 267, 269, 283.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn28",
      "id": "rfn28"
    }
  }, [_vm._v("28")]), _vm._v(". FC SD 6.7, 24, in "), _c('i', [_vm._v("BC")]), _vm._v(", 588, 591. There are internal Lutheran debates, related to the third use of the law, about the implications of insisting that the law is for the old age and thus for the Christian "), _c('i', [_vm._v("qua peccator")]), _vm._v(": Does the third use mean the political and theological uses are still operative for the Christian, does third use name an additional, distinctive, and didactic use for the Christian, or is the notion of a third use of the law problematic?")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn29",
      "id": "rfn29"
    }
  }, [_vm._v("29")]), _vm._v(". Bavinck, "), _c('i', [_vm._v("Reformed Dogmatics")]), _vm._v(", 4:455.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn30",
      "id": "rfn30"
    }
  }, [_vm._v("30")]), _vm._v(". Bavinck, "), _c('i', [_vm._v("Reformed Dogmatics")]), _vm._v(", 4:455.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn31",
      "id": "rfn31"
    }
  }, [_vm._v("31")]), _vm._v(". Bavinck, "), _c('i', [_vm._v("Reformed Dogmatics")]), _vm._v(", 4:455. Luther, in his lectures on Genesis, addresses the question of the relationship between the law Paul refers to in texts like 1 Tim. 1:9 and the command and prohibition of Gen. 2:16–17 and concludes that it is necessary to make a “distinction between the law given before sin and that given after sin” ("), _c('i', [_vm._v("LW")]), _vm._v(" 1:109).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn32",
      "id": "rfn32"
    }
  }, [_vm._v("32")]), _vm._v(". Calvin, "), _c('i', [_vm._v("Institutes")]), _vm._v(" 2.7.13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn33",
      "id": "rfn33"
    }
  }, [_vm._v("33")]), _vm._v(". "), _c('i', [_vm._v("LW")]), _vm._v(" 26:309.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn34",
      "id": "rfn34"
    }
  }, [_vm._v("34")]), _vm._v(". Calvin, "), _c('i', [_vm._v("Institutes")]), _vm._v(" 2.7.12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn35",
      "id": "rfn35"
    }
  }, [_vm._v("35")]), _vm._v(". Bavinck, "), _c('i', [_vm._v("Reformed Dogmatics")]), _vm._v(", 4:455.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn36",
      "id": "rfn36"
    }
  }, [_vm._v("36")]), _vm._v(". W. Elert, "), _c('i', [_vm._v("Law and Gospel")]), _vm._v(", trans. E. H. Schroeder (Philadelphia: Fortress, 1967).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn37",
      "id": "rfn37"
    }
  }, [_vm._v("37")]), _vm._v(". K. Barth, “Gospel and Law,” in "), _c('i', [_vm._v("Community, State, and Church")]), _vm._v(" (New York: Doubleday, 1960), 71–100.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn38",
      "id": "rfn38"
    }
  }, [_vm._v("38")]), _vm._v(". Elert, "), _c('i', [_vm._v("Law and Gospel")]), _vm._v(", 41–42.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn39",
      "id": "rfn39"
    }
  }, [_vm._v("39")]), _vm._v(". Elert, "), _c('i', [_vm._v("Law and Gospel")]), _vm._v(", 43, 45.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn40",
      "id": "rfn40"
    }
  }, [_vm._v("40")]), _vm._v(". "), _c('i', [_vm._v("LW")]), _vm._v(" 26:310.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn41",
      "id": "rfn41"
    }
  }, [_vm._v("41")]), _vm._v(". Elert, "), _c('i', [_vm._v("Law and Gospel")]), _vm._v(", 47–48.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn42",
      "id": "rfn42"
    }
  }, [_vm._v("42")]), _vm._v(". H. Sasse, "), _c('i', [_vm._v("Here We Stand: Nature and Character of the Lutheran Faith")]), _vm._v(", trans. T. G. Tappert (Adelaide, Australia: Lutheran Publishing House, 1979), 129.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn43",
      "id": "rfn43"
    }
  }, [_vm._v("43")]), _vm._v(". Berkhof, "), _c('i', [_vm._v("Systematic Theology")]), _vm._v(", 615.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn44",
      "id": "rfn44"
    }
  }, [_vm._v("44")]), _vm._v(". Bavinck, "), _c('i', [_vm._v("Reformed Dogmatics")]), _vm._v(", 4:448, 455.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn45",
      "id": "rfn45"
    }
  }, [_vm._v("45")]), _vm._v(". Luther, "), _c('i', [_vm._v("Solus Decalogus est Aeternus")]), _vm._v(", 137. See, however, Ursinus, who in the "), _c('i', [_vm._v("Commentary on the Heidelberg Catechism")]), _vm._v(" defines the law and differentiates it from the gospel in terms of its “effects” as well as its “mode of revelation” and “conditions” (497).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn46",
      "id": "rfn46"
    }
  }, [_vm._v("46")]), _vm._v(". See especially Michael Allen’s essay in this book. Covenant theology is therefore part of the way Reformed theology would answer Elert’s charge that in the Reformed tradition the creator-creature relationship is regulated by the law rather than the gospel. Because the relationship is covenantal, it includes nomistic aspects, but the relationship itself is anchored in grace, in an act of “voluntary condescension on God’s part” (WCF 7.1).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn47",
      "id": "rfn47"
    }
  }, [_vm._v("47")]), _vm._v(". G. Ebeling, "), _c('i', [_vm._v("Word and Faith")]), _vm._v(", trans. J. W. Leitch (Philadelphia: Fortress, 1963), 270. For Oswald Bayer, any attempt to posit a unity ("), _c('i', [_vm._v("Einheit")]), _vm._v(") of law and gospel forgets that “the theology we do en route as pilgrims ("), _c('i', [_vm._v("theologia viatorum")]), _vm._v(") is stamped by the . . . irreducibly different ways which God encounters us,” namely, law and gospel, though Bayer would also include divine hiddenness ("), _c('i', [_vm._v("Theology the Lutheran Way")]), _vm._v(", trans. J. G. Silcock and M. C. Mattes [Grand Rapids: Eerdmans, 2007], 105).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn48",
      "id": "rfn48"
    }
  }, [_vm._v("48")]), _vm._v(". Calvin, "), _c('i', [_vm._v("Institutes")]), _vm._v(" 1.1.1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn49",
      "id": "rfn49"
    }
  }, [_vm._v("49")]), _vm._v(". "), _c('i', [_vm._v("LW")]), _vm._v(" 12:311.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn50",
      "id": "rfn50"
    }
  }, [_vm._v("50")]), _vm._v(". Katherine Sonderegger and Erik Herrmann, in their essays in this book, consider this issue of the scope of theology, in terms of both the range of what God does through his word (Sonderegger) and the characteristic theological modes of the Lutheran and Reformed traditions (Herrmann).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn51",
      "id": "rfn51"
    }
  }, [_vm._v("51")]), _vm._v(". Cranmer to Melanchthon (1549), in J. E. Cox, "), _c('i', [_vm._v("Miscellaneous Writings and Letters of Thomas Cranmer")]), _vm._v(" (Cambridge: Parker Society, 1846; reproduced by Regent College Publishing), 426.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn52",
      "id": "rfn52"
    }
  }, [_vm._v("52")]), _vm._v(". Calvin to Cranmer (1552), in "), _c('i', [_vm._v("Original Letters Relative to the English Reformation")]), _vm._v(", ed. H. Robinson for the Parker Society (Cambridge: Cambridge University Press, 1847), 711.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn53",
      "id": "rfn53"
    }
  }, [_vm._v("53")]), _vm._v(". Calvin to Cranmer, 713.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn54",
      "id": "rfn54"
    }
  }, [_vm._v("54")]), _vm._v(". Calvin to Cranmer, 713.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ee3c7f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/introduction.vue
// module id = 75
// module chunks = 0